import { Text } from 'src/design/atoms/Text';
import React from 'react';
import { DeleteButton } from 'src/design/atoms/DeleteButton';
import { Modal } from 'src/design/molecules/Modal';

interface ConfirmDeletePostModalProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  deleting: boolean;
}

export const ConfirmDeletePostModal: React.FC<ConfirmDeletePostModalProps> = ({
  open,
  onConfirm,
  onCancel,
  deleting,
}) => {
  return (
    <Modal
      opened={open}
      onClose={onCancel}
      title="Are you sure?"
      size="sm"
      actions={[
        <DeleteButton key="delete" onClick={onConfirm} loading={deleting}>
          Delete Post
        </DeleteButton>,
      ]}
    >
      <Text>Are you sure you want to permanently delete this post?</Text>
    </Modal>
  );
};
